import { c as _c } from "react/compiler-runtime";
import { Card, Shimmer } from '@onefootprint/ui';
type CardSkeletonProps = {
  cards?: number;
  rows?: number;
};

// Shimmer widths per row, so the lines don't read as one solid block.
const ROW_WIDTHS = ['70%', '45%', '60%', '35%'];
const keys = (count: number, prefix: string) => Array.from({
  length: count
}, (_, index) => `${prefix}-${index}`);

/** Loading cards in the shape the loaded tab will take: a title strip over a white body. */
const CardSkeleton = t0 => {
  const $ = _c(7);
  const {
    cards: t1,
    rows: t2
  } = t0;
  const cards = t1 === undefined ? 1 : t1;
  const rows = t2 === undefined ? 2 : t2;
  let t3;
  if ($[0] !== cards || $[1] !== rows) {
    let t4;
    if ($[3] !== rows) {
      t4 = card => <Card.Root key={card}><div className="mb-1 flex h-6 items-center px-2"><Shimmer height="12px" width="96px" className="bg-senary" /></div><Card.Body className="flex flex-col gap-2 p-4">{keys(rows, "row").map(_temp)}</Card.Body></Card.Root>;
      $[3] = rows;
      $[4] = t4;
    } else {
      t4 = $[4];
    }
    t3 = keys(cards, "card").map(t4);
    $[0] = cards;
    $[1] = rows;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <div className="flex w-full flex-col gap-3">{t3}</div>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export default CardSkeleton;
function _temp(row, index) {
  return <Shimmer key={row} height="14px" width={ROW_WIDTHS[index % ROW_WIDTHS.length]} />;
}